import React from 'react'
import { useLocation, Link } from 'react-router-dom';

const LinkContainer = ({Icon, title, to}) => {
  const { pathname } = useLocation();

  return (
    <>
        <Link to={to} className={`transition-all mb-2 mx-auto w-[90%] rounded-[10px] hover:bg-primary group flex space-x-3 py-3 px-4 items-center justify-start ${pathname === to ? "bg-primary" : ""}`}>
            <Icon className={`transition-all flex-shrink-0 group-hover:text-white text-xl ${pathname === to ? "text-white" : "text-primary/80"}`} />
            <span className={`transition-all text-sm font-medium group-hover:text-white  ${pathname === to ? "text-white" : "text-primary/80"}`}>
              {
                title
              }
            </span>
      </Link>
    </>
  )
}

export default LinkContainer